import React, {PureComponent} from 'react';
import toastr from 'toastr';

import {getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import countriesDialCodes from '../../common/countriesDialCodes.json';
import Header from '../Header'
import { Route, Switch } from 'react-router-dom'

import AccountVerificationDetails from './AccountVerificationDetails';
import AccountVerificationFinish from './AccountVerificationFinish';
import AccountVerificationRepresentativeDetails from './AccountVerificationRepresentativeDetails';
import AccountVerificationSelectType from './AccountVerificationSelectType';

export default class AccountVerification extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            verifiedData: '',
            selectedVerificationStep: 'Type Selection',
            selectedType: 'Registered business',
            spinner: false,
            businessDetails: {
                businessName: '',
                businessWebsite: '',
                businessIdNumber: '',
                businessVatNumber: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                country: 'Select Country',
                files: []
            },
            personalDetails: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    iso2: 'us',
                    dialCode: '1',
                    phone: ''
                },
                formatedPhone: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                country: 'Select Country',
                files: []
            },
            authorizedRepresentative: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    iso2: 'us',
                    dialCode: '1',
                    phone: ''
                },
                formatedPhone: '',
                usingOnBehalfOf: 'This Business',
            },
            clientBusinessDetails: {
                businessName: '',
                businessWebsite: '',
                businessIdNumber: '',
                businessVatNumber: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                country: 'Select Country',
            },
            clientContactPersonDetails: {
                firstName: '',
                lastName: '',
                email: '',
                phone: {
                    iso2: 'us',
                    dialCode: '1',
                    phone: ''
                },
                formatedPhone: '',
                agreedToTerms: false
            },
        };
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
        // console.log('Errors list data: ', error, id, errorsList);
    }

    handleUpdateSelectedType = (type) => {
        this.setState({selectedType: type})
    }

    handleGoToAccountVerificationDetails = () => {
        if(this.state.selectedType === 'Registered business'){
            this.props.history.push('/account-verification/business-details')
        }else if(this.state.selectedType === 'Individual'){
            this.props.history.push('/account-verification/personal-details')
        }
    }

    handleUpdateProperty = async (objectName, propertyName, value) => {
        // console.log('handleUpdateProperty: ', objectName, propertyName, value)
        await this.setState({
            [objectName]:{
                ...this.state[objectName],
                [propertyName]:value
            }
        })
    }

    handleSubmitPersonalDetails = async () => {
        let basic_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
            this.props.selectedSourceNode.business_verification.business_address &&
            this.props.selectedSourceNode.business_verification.business_address.basic_info_valid

        let documentation_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
            this.props.selectedSourceNode.business_verification.documentation &&
            this.props.selectedSourceNode.business_verification.documentation.documentation_info_valid

        let representative_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
            this.props.selectedSourceNode.business_verification.authorised_representative &&
            this.props.selectedSourceNode.business_verification.authorised_representative.representative_info_valid
        this.setState({spinner: true})

        let data = {
            ...(!basic_info_valid && { type: "individual" }),
            ...(!basic_info_valid && { business_address:
                    {
                        address_line_1: this.state.personalDetails.addressLine1,
                        address_line_2: this.state.personalDetails.addressLine2,
                        city: this.state.personalDetails.city,
                        state: this.state.personalDetails.state,
                        zip_code: this.state.personalDetails.zipCode,
                        country: this.state.personalDetails.country
                    }
            }),
            ...(!representative_info_valid && { authorised_representative:
                {
                    first_name: this.state.personalDetails.firstName,
                    last_name: this.state.personalDetails.lastName,
                    email: this.state.personalDetails.email,
                    phone_number: this.state.personalDetails.formatedPhone
                }
            }),
            ...(!documentation_info_valid && { documentation: this.state.personalDetails.files}),
        }
        try {
            if(this.props.selectedSourceNode.business_verification && this.props.selectedSourceNode.business_verification.type &&
                this.props.selectedSourceNode.business_verification.id){
                let result = await http.patch('api/user/' + this.props.user.id + '/project/' + this.props.selectedSource + '/bv/' + this.props.selectedSourceNode.business_verification.id, {
                    ...data
                }, {headers: {authorization: getJwt()} });
            }else{
                let result = await http.post('api/user/' + this.props.user.id + '/project/' + this.props.selectedSource + '/bv', {
                    ...data
                }, {headers: {authorization: getJwt()} });
            }


            this.setState({ spinner: false })
            this.props.updateUserFromServer();
            this.props.history.push('/account-verification/finish')
        } catch (ex) {
            this.setState({spinner: false})
            toastr.error("Something went wrong... Please try again.");
        }
    }

    handleSubmitBusinessDetails = async (finalStep) => {

        let basic_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                this.props.selectedSourceNode.business_verification.business_address &&
                this.props.selectedSourceNode.business_verification.business_address.basic_info_valid

        let documentation_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                this.props.selectedSourceNode.business_verification.documentation &&
                this.props.selectedSourceNode.business_verification.documentation.documentation_info_valid

        let representative_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
            this.props.selectedSourceNode.business_verification.authorised_representative &&
            this.props.selectedSourceNode.business_verification.authorised_representative.representative_info_valid

        let cb_basic_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
            this.props.selectedSourceNode.business_verification.client_business &&
            this.props.selectedSourceNode.business_verification.client_business.cb_basic_info_valid

        let cb_representative_info_valid = this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
            this.props.selectedSourceNode.business_verification.client_business &&
            this.props.selectedSourceNode.business_verification.client_business.cb_representative_info_valid

        this.setState({spinner: true})

        if(finalStep){
            let data = {
                ...(!basic_info_valid && { type: this.state.authorizedRepresentative.usingOnBehalfOf === 'This Business' ? 'business' : 'business4business' }),
                ...(!basic_info_valid && { business_name: this.state.businessDetails.businessName }),
                ...(!basic_info_valid && { business_id_number: this.state.businessDetails.businessIdNumber }),
                ...(!basic_info_valid && { business_vat_number:this.state.businessDetails.businessVatNumber}),
                ...(!basic_info_valid && { website: this.state.businessDetails.businessWebsite }),
                ...(!basic_info_valid && { business_address: {
                        address_line_1: this.state.businessDetails.addressLine1,
                        address_line_2: this.state.businessDetails.addressLine2,
                        city: this.state.businessDetails.city,
                        state: this.state.businessDetails.state,
                        zip_code: this.state.businessDetails.zipCode,
                        country: this.state.businessDetails.country
                    }
                }),
                ...(!representative_info_valid && { authorised_representative: {
                        first_name: this.state.authorizedRepresentative.firstName,
                        last_name: this.state.authorizedRepresentative.lastName,
                        email: this.state.authorizedRepresentative.email,
                        phone_number: this.state.authorizedRepresentative.formatedPhone
                    }
                }),
                ...((this.state.authorizedRepresentative.usingOnBehalfOf !== 'This Business') &&
                    (!cb_basic_info_valid || !cb_representative_info_valid ) && { client_business: {
                            business_name: this.state.clientBusinessDetails.businessName,
                            business_id_number: this.state.clientBusinessDetails.businessIdNumber,
                            business_vat_number: this.state.clientBusinessDetails.businessVatNumber,
                            website: this.state.clientBusinessDetails.businessWebsite,
                            business_address: {
                                address_line_1: this.state.clientBusinessDetails.addressLine1,
                                address_line_2: this.state.clientBusinessDetails.addressLine2,
                                city: this.state.clientBusinessDetails.city,
                                state: this.state.clientBusinessDetails.state,
                                zip_code: this.state.clientBusinessDetails.zipCode,
                                country: this.state.clientBusinessDetails.country
                            },
                            authorised_representative: {
                                first_name: this.state.clientContactPersonDetails.firstName,
                                last_name: this.state.clientContactPersonDetails.lastName,
                                email: this.state.clientContactPersonDetails.email,
                                phone_number: this.state.clientContactPersonDetails.formatedPhone
                            }
                        }
                }),
                ...(!documentation_info_valid && { documentation: this.state.businessDetails.files}),
            }
            try {
                if(this.props.selectedSourceNode.business_verification && this.props.selectedSourceNode.business_verification.type &&
                    this.props.selectedSourceNode.business_verification.id){
                    let result = await http.patch('api/user/' + this.props.user.id + '/project/' + this.props.selectedSource + '/bv/' + this.props.selectedSourceNode.business_verification.id, {
                        ...data
                    }, {headers: {authorization: getJwt()} });
                }else{
                    let result = await http.post('api/user/' + this.props.user.id + '/project/' + this.props.selectedSource + '/bv', {
                        ...data
                    }, {headers: {authorization: getJwt()} });
                }

                this.setState({ spinner: false })
                this.props.updateUserFromServer();
                this.handleNavigateAfterSubmit()
            } catch (ex) {
                this.setState({spinner: false})
                toastr.error("Something went wrong... Please try again.");
            }
        }else{
            this.setState({ spinner: false })
            this.handleNavigateAfterSubmit()
        }

    }

    handleNavigateAfterSubmit = () => {
        if(window.location.pathname === '/account-verification/business-details'){
            this.props.history.push('/account-verification/authorized-representative-details')
        }else if(window.location.pathname === '/account-verification/authorized-representative-details'){
            if(this.state.authorizedRepresentative.usingOnBehalfOf === 'This Business'){
                this.props.history.push('/account-verification/finish')
            }else if(this.state.authorizedRepresentative.usingOnBehalfOf === 'My Client Business'){
                this.props.history.push('/account-verification/client-business-details')
            }
        }else if(window.location.pathname === '/account-verification/client-business-details'){
            this.props.history.push('/account-verification/client-contact-person-details')
        }else if(window.location.pathname === '/account-verification/client-contact-person-details'){
            this.props.history.push('/account-verification/finish')
        }
    }

    handleAddInitialDataToState = () => {
        let verif = this.props.selectedSourceNode.business_verification;
        // console.log('verif: ', verif, this.state.verifedData)
        if( verif && !this.state.verifiedData && (verif.type === 'individual')){
            let callingCode = '+1';
            countriesDialCodes.find(code => verif.authorised_representative.phone_number.startsWith(code) ? callingCode = code : '')
            let files = verif.documentation ? Object.values(verif.documentation) : []
            files.pop();
            this.setState({
                verifiedData: verif,
                personalDetails: {
                    firstName: verif.authorised_representative.first_name ? verif.authorised_representative.first_name : '',
                    lastName: verif.authorised_representative.last_name ? verif.authorised_representative.last_name : '',
                    email: verif.authorised_representative.email ? verif.authorised_representative.email : '',
                    phone: {
                        iso2: callingCode === '+1' ? 'us' : '',
                        dialCode: callingCode.substring(1),
                        phone: verif.authorised_representative.phone_number ? verif.authorised_representative.phone_number : '',
                    },
                    formatedPhone: verif.authorised_representative.phone_number ? verif.authorised_representative.phone_number : '',
                    addressLine1: verif.business_address.address_line_1 ? verif.business_address.address_line_1 : '',
                    addressLine2: verif.business_address.address_line_2 ? verif.business_address.address_line_2 : '',
                    city: verif.business_address.city ? verif.business_address.city : '',
                    state: verif.business_address.state ? verif.business_address.state : '',
                    zipCode: verif.business_address.zip_code ? verif.business_address.zip_code : '',
                    country: verif.business_address.country ? verif.business_address.country : 'Select Country',
                    files
                },

            })
        }else if( verif && !this.state.verifiedData && ((verif.type === 'business') || (verif.type === 'business4business') )){
            let callingCode = '+1';
            if(verif && verif.authorised_representative && verif.authorised_representative.phone_number){
                countriesDialCodes.find(code => verif.authorised_representative.phone_number.startsWith(code) ? callingCode = code : '')
            }
            let clientCallingCode = '+1';
            if(verif && verif.client_business && verif.client_business.authorised_representative && verif.client_business.authorised_representative.phone_number){
                countriesDialCodes.find(code => verif.client_business.authorised_representative.phone_number.startsWith(code) ? callingCode = code : '')
            }
            let files = verif.documentation ? Object.values(verif.documentation) : []
            files.pop();
            this.setState({
                verifiedData: verif,
                businessDetails: {
                    businessName: verif.business_name ? verif.business_name : '',
                    businessWebsite: verif.website ? verif.website : '',
                    businessIdNumber: verif.business_id_number ? verif.business_id_number : '',
                    businessVatNumber: verif.business_vat_number ? verif.business_vat_number : '',
                    addressLine1: verif.business_address.address_line_1 ? verif.business_address.address_line_1 : '',
                    addressLine2: verif.business_address.address_line_2 ? verif.business_address.address_line_2 : '',
                    city: verif.business_address.city ? verif.business_address.city : '',
                    state: verif.business_address.state ? verif.business_address.state : '',
                    zipCode: verif.business_address.zip_code ? verif.business_address.zip_code : '',
                    country: verif.business_address.country ? verif.business_address.country : 'Select Country',
                    files
                },
                authorizedRepresentative: {
                    firstName: verif.authorised_representative.first_name ? verif.authorised_representative.first_name : '',
                    lastName: verif.authorised_representative.last_name ? verif.authorised_representative.last_name : '',
                    email: verif.authorised_representative.email ? verif.authorised_representative.email : '',
                    phone: {
                        iso2: callingCode === '+1' ? 'us' : '',
                        dialCode: callingCode.substring(1),
                        phone: verif.authorised_representative.phone_number ? verif.authorised_representative.phone_number : '',
                    },
                    usingOnBehalfOf: verif.type === 'business4business' ? 'My Client Business' : 'This Business',
                    formatedPhone: verif.authorised_representative.phone_number ? verif.authorised_representative.phone_number : '',
                },
                clientBusinessDetails: !verif.client_business ? this.state.clientBusinessDetails : {
                    businessName: verif.client_business.business_name || '',
                    businessWebsite: verif.client_business.website || '',
                    businessIdNumber: verif.client_business.business_id_number || '',
                    businessVatNumber: verif.client_business.business_vat_number || '',
                    addressLine1: verif.client_business.business_address.address_line_1 || '',
                    addressLine2: verif.client_business.business_address.address_line_2 || '',
                    city: verif.client_business.business_address.city || '',
                    state: verif.client_business.business_address.state || '',
                    zipCode: verif.client_business.business_address.zip_code || '',
                    country: verif.client_business.business_address.country || '',
                },
                clientContactPersonDetails: !verif.client_business ? this.state.clientContactPersonDetails :{
                    firstName: verif.client_business.authorised_representative.first_name || '',
                    lastName: verif.client_business.authorised_representative.last_name || '',
                    email: verif.client_business.authorised_representative.email || '',
                    phone: {
                        iso2: clientCallingCode === '+1' ? 'us' : '',
                        dialCode: clientCallingCode.substring(1),
                        phone: verif.client_business.authorised_representative.phone_number || ''
                    },
                    formatedPhone: verif.client_business.authorised_representative.phone_number || '' ,
                    agreedToTerms: false
                },
            })
        }
    }

    componentDidMount() {
        let verif = this.props.selectedSourceNode.business_verification;

        if(verif && !this.state.verifiedData){
            this.handleAddInitialDataToState()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        let verif = this.props.selectedSourceNode.business_verification;

        if(verif && !this.state.verifiedData){
            this.handleAddInitialDataToState()
        }
    }


    render() {
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="account-verification-panel">
                        <Switch>
                            <Route path="/account-verification/select-type"
                                   render={(props) => <AccountVerificationSelectType
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       selectedType={this.state.selectedType}
                                       handleUpdateSelectedType={this.handleUpdateSelectedType}
                                       handleGoToAccountVerificationDetails={this.handleGoToAccountVerificationDetails}
                                   {...props}/> }
                            />
                            <Route path="/account-verification/business-details"
                                   render={(props) => <AccountVerificationDetails
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       selectedVerificationStep={this.state.selectedVerificationStep}
                                       selectedType={this.state.selectedType}
                                       spinner={this.state.spinner}
                                       businessDetails={this.state.businessDetails}
                                       clientBusinessDetails={this.state.clientBusinessDetails}
                                       clientContactPersonDetails={this.state.clientContactPersonDetails}
                                       handleUpdateProperty={this.handleUpdateProperty}
                                       handleSubmitBusinessDetails={this.handleSubmitBusinessDetails}

                                       verificationRejected={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       (this.props.selectedSourceNode.business_verification.status === 'rejected') }

                                       stepVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       this.props.selectedSourceNode.business_verification.business_address &&
                                       this.props.selectedSourceNode.business_verification.business_address.basic_info_valid}

                                       documentationVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       this.props.selectedSourceNode.business_verification.documentation &&
                                       this.props.selectedSourceNode.business_verification.documentation.documentation_info_valid}

                                       {...props}/> }
                            />
                            <Route path="/account-verification/personal-details"
                                   render={(props) => <AccountVerificationDetails
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       selectedVerificationStep={this.state.selectedVerificationStep}
                                       selectedType={this.state.selectedType}
                                       spinner={this.state.spinner}
                                       personalDetails= {this.state.personalDetails}
                                       authorizedRepresentative={this.state.authorizedRepresentative}
                                       clientBusinessDetails={this.state.clientBusinessDetails}
                                       clientContactPersonDetails={this.state.clientContactPersonDetails}
                                       handleUpdateProperty={this.handleUpdateProperty}
                                       handleSubmitPersonalDetails={this.handleSubmitPersonalDetails}

                                       verificationRejected={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       (this.props.selectedSourceNode.business_verification.status === 'rejected') }

                                       stepVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       (this.props.selectedSourceNode.business_verification.business_address.basic_info_valid ||
                                       this.props.selectedSourceNode.business_verification.authorised_representative.representative_info_valid)}

                                       documentationVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       this.props.selectedSourceNode.business_verification.documentation &&
                                       this.props.selectedSourceNode.business_verification.documentation.documentation_info_valid}

                                       {...props}/> }
                            />
                            <Route path="/account-verification/authorized-representative-details"
                                   render={(props) => <AccountVerificationRepresentativeDetails
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       spinner={this.state.spinner}
                                       authorizedRepresentative={this.state.authorizedRepresentative}
                                       handleUpdateProperty={this.handleUpdateProperty}
                                       handleSubmitBusinessDetails={this.handleSubmitBusinessDetails}

                                       verificationRejected={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       (this.props.selectedSourceNode.business_verification.status === 'rejected') }

                                       stepVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       this.props.selectedSourceNode.business_verification.authorised_representative.representative_info_valid}

                                       {...props}/> }
                            />
                            <Route path="/account-verification/client-business-details"
                                   render={(props) => <AccountVerificationDetails
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       selectedVerificationStep={this.state.selectedVerificationStep}
                                       selectedType={this.state.selectedType}
                                       spinner={this.state.spinner}
                                       clientBusinessDetails={this.state.clientBusinessDetails}
                                       clientContactPersonDetails={this.state.clientContactPersonDetails}
                                       handleUpdateProperty={this.handleUpdateProperty}
                                       handleSubmitBusinessDetails={this.handleSubmitBusinessDetails}

                                       verificationRejected={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       (this.props.selectedSourceNode.business_verification.status === 'rejected') }

                                       stepVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       this.props.selectedSourceNode.business_verification.client_business &&
                                       this.props.selectedSourceNode.business_verification.client_business.cb_basic_info_valid}

                                       {...props}/> }
                            />
                            <Route path="/account-verification/client-contact-person-details"
                                   render={(props) => <AccountVerificationRepresentativeDetails
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       spinner={this.state.spinner}
                                       clientContactPersonDetails={this.state.clientContactPersonDetails}
                                       handleUpdateProperty={this.handleUpdateProperty}
                                       handleSubmitBusinessDetails={this.handleSubmitBusinessDetails}

                                       verificationRejected={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       (this.props.selectedSourceNode.business_verification.status === 'rejected') }

                                       stepVerified={this.props.selectedSourceNode && this.props.selectedSourceNode.business_verification &&
                                       this.props.selectedSourceNode.business_verification.client_business &&
                                       this.props.selectedSourceNode.business_verification.client_business.cb_representative_info_valid}

                                       {...props}/> }
                            />
                            <Route path="/account-verification/finish"
                                   render={(props) => <AccountVerificationFinish
                                       user={this.props.user}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       spinner={this.state.spinner}
                                       clientContactPersonDetails={this.state.clientContactPersonDetails}
                                       handleUpdateProperty={this.handleUpdateProperty}
                                       {...props}/> }
                            />
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}
